// based on https://github.com/ksheedlo/isomorphic-base64 to use in client and server envs interchangeably.
// due to lack of types, reimplemented and maintained here.

export function atob(val: string) {
	return new Buffer(val, 'base64').toString();
}

export function btoa(val: string) {
	return new Buffer(val).toString('base64');
}
